import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <header className="bg-white border-b sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-3">
          <Link to="/">
            <ArrowLeft className="w-5 h-5 text-muted-foreground hover:text-foreground" />
          </Link>
          <h1 className="text-lg font-bold">Politique de confidentialite</h1>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="bg-white rounded-2xl border p-6 sm:p-10 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <div>
            <h2 className="text-xl font-bold text-foreground mb-2">Politique de confidentialite - Green Teva Energie</h2>
            <p>Derniere mise a jour : Mars 2026</p>
          </div>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">1. Responsable du traitement</h3>
            <p>Green Teva Energie<br />
            Email : contact@greenteva-energies.fr<br />
            Le responsable du traitement est la societe Green Teva Energie, ci-apres "nous" ou "la Plateforme".</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">2. Donnees collectees</h3>
            <p>Dans le cadre de l'utilisation de notre plateforme de cooperative energetique, nous collectons les donnees suivantes :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Donnees d'identification :</strong> nom, prenom, adresse email, numero de telephone</li>
              <li><strong>Donnees de localisation :</strong> adresse postale complete</li>
              <li><strong>Donnees energetiques :</strong> numero de Point de Livraison (PDL) Linky, donnees de consommation et de production d'electricite</li>
              <li><strong>Donnees financieres :</strong> IBAN, BIC pour le versement des revenus de production</li>
              <li><strong>Donnees de connexion :</strong> adresse IP, logs de connexion, donnees de navigation</li>
              <li><strong>Donnees de compte :</strong> mot de passe (chiffre et non accessible), role, type d'utilisateur</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">3. Finalites du traitement</h3>
            <p>Vos donnees sont traitees pour les finalites suivantes :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Gestion de votre compte et authentification</li>
              <li>Fonctionnement de la cooperative energetique (echanges d'energie, facturation, suivi)</li>
              <li>Calcul et versement des revenus de production et commissions</li>
              <li>Communication par email (notifications, confirmations, recapitulatifs)</li>
              <li>Amelioration de nos services et statistiques anonymisees</li>
              <li>Respect des obligations legales et reglementaires</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">4. Base legale du traitement</h3>
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Execution du contrat :</strong> gestion de votre compte et des echanges d'energie</li>
              <li><strong>Consentement :</strong> envoi de communications et cookies non essentiels</li>
              <li><strong>Interet legitime :</strong> amelioration de la plateforme, securite</li>
              <li><strong>Obligation legale :</strong> conservation des donnees de facturation</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">5. Duree de conservation</h3>
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Donnees de compte actif :</strong> pendant toute la duree de votre inscription</li>
              <li><strong>Donnees apres suppression de compte :</strong> anonymisees sous 30 jours</li>
              <li><strong>Donnees de facturation :</strong> 10 ans (obligation legale comptable)</li>
              <li><strong>Logs de connexion :</strong> 12 mois</li>
              <li><strong>Cookies :</strong> 13 mois maximum</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">6. Destinataires des donnees</h3>
            <p>Vos donnees peuvent etre transmises aux destinataires suivants :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Personnel autorise de Green Teva Energie</li>
              <li>Prestataires techniques (hebergement, envoi d'emails)</li>
              <li>Enedis (dans le cadre de l'acces aux donnees Linky, avec votre consentement)</li>
              <li>Organismes financiers (pour les virements et prelevements)</li>
              <li>Autorites publiques sur demande legale</li>
            </ul>
            <p className="mt-2">Aucune donnee n'est transferee hors de l'Union Europeenne.</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">7. Vos droits (articles 15 a 22 du RGPD)</h3>
            <p>Conformement au Reglement General sur la Protection des Donnees (RGPD) et a la loi Informatique et Libertes, vous disposez des droits suivants :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Droit d'acces :</strong> obtenir une copie de vos donnees personnelles</li>
              <li><strong>Droit de rectification :</strong> corriger vos donnees inexactes ou incompletes</li>
              <li><strong>Droit a l'effacement :</strong> demander la suppression de vos donnees</li>
              <li><strong>Droit a la portabilite :</strong> recevoir vos donnees dans un format structure</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos donnees</li>
              <li><strong>Droit a la limitation :</strong> demander la limitation du traitement</li>
              <li><strong>Droit de retirer votre consentement :</strong> a tout moment</li>
            </ul>
            <p className="mt-2">Pour exercer ces droits, rendez-vous dans votre espace "Mon Profil" ou contactez-nous a <strong>contact@greenteva-energies.fr</strong>.</p>
            <p className="mt-2">Vous pouvez egalement introduire une reclamation aupres de la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des Libertes) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-green-600 underline">www.cnil.fr</a></p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">8. Cookies</h3>
            <p>Notre plateforme utilise les cookies suivants :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Cookies strictement necessaires :</strong> authentification, securite, preferences de session (pas de consentement requis)</li>
              <li><strong>Cookies analytiques :</strong> mesure d'audience anonymisee (soumis a votre consentement)</li>
            </ul>
            <p className="mt-2">Vous pouvez gerer vos preferences de cookies a tout moment via le bandeau cookies ou les parametres de votre navigateur.</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">9. Securite</h3>
            <p>Nous mettons en oeuvre des mesures techniques et organisationnelles appropriees pour proteger vos donnees : chiffrement des mots de passe, connexions securisees (HTTPS), acces restreint aux donnees, sauvegardes regulieres.</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">10. Contact</h3>
            <p>Pour toute question relative a la protection de vos donnees personnelles :</p>
            <p className="mt-1"><strong>Green Teva Energie</strong><br />
            Email : contact@greenteva-energies.fr</p>
          </section>
        </div>
      </main>
    </div>
  );
}
